var Vue = require('vue');
var app = require('../../components/app/app.vue');
var VueResource = require('vue-resource');
var loadCss = require('fg-loadcss');
var loadScript = require('load-script');
require('../../assets/js/directives.js');

Vue.use(VueResource);

if(typeof BASIC_AUTH !== 'undefined') {
    Vue.http.headers.common['Authorization'] = BASIC_AUTH;
}

Vue.filter('numberFilter', function(value) {
    value = value.toString().replace(/\./g, ',');
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

window.app = new Vue({
    el: 'body',
    components: {
        "app": app
    },
    methods: {
        initMap: function() {
            this.$broadcast('mapReady');
        }
    }
});

var fonts = loadCss.loadCSS(BASE_URL + '/stylesheets/fonts.css?v=' + VERSION);
fonts.onloadcssdefined(function() {
    window.app.$broadcast('fonts-loaded');
});

loadScript(BASE_URL + '/js/resultarea.js?v=' + VERSION, function(err, script) {
   if(!err) {
       window.app.$broadcast('resultareaready', true);
   } else {
       window.app.$broadcast('showmsg', {type: 'error', messages: [TRANSLATIONS['errors']['genereal_load_erorr']]});
   }
});
loadCss.loadCSS(BASE_URL + '/stylesheets/result-area.css?v=' + VERSION);